<template>
  <div class="collocation">
    <el-form
      label-position="right"
      :rules="rules"
      label-width="160px"
      ref="ruleForm"
      :model="datasArr"
    >
      <el-form-item label="封面：" prop="cover">
        <el-upload
          class="avatar-uploader"
          action
          :show-file-list="false"
          :before-upload="beforeAvatarUpload"
        >
          <img v-if="cover" :src="cover" class="avatar" alt="加载失败" />
          <em v-else class="el-icon-plus avatar-uploader-icon"></em>
        </el-upload>
      </el-form-item>
      <el-form-item label="类型：" prop="bannertype">
        <el-select
          v-model="bannertype"
          @change="changetype"
          placeholder="请选择"
        >
          <el-option
            v-for="item in bannertypeArr"
            :key="item.id"
            :label="item.name"
            :value="item.id"
          ></el-option>
        </el-select>
      </el-form-item>
      <el-form-item
        v-show="bannertype == 1"
        label="web_url："
        prop="extra_info"
      >
        <el-input v-model="datasArr.web_url"></el-input>
      </el-form-item>
      <el-form-item
        v-show="bannertype == 3 || bannertype == 5 || bannertype == 27"
        label="target_id："
        prop="extra_info"
      >
        <el-input v-model="datasArr.target_id"></el-input>
      </el-form-item>
      <el-form-item
        v-show="bannertype == 6"
        label="keywords："
        prop="extra_info"
      >
        <el-input v-model="datasArr.keywords"></el-input>
      </el-form-item>
      <el-form-item v-show="bannertype == 11" label="appid：" prop="extra_info">
        <el-input v-model="datasArr.appid"></el-input>
      </el-form-item>
      <el-form-item
        v-show="bannertype == 11"
        label="username："
        prop="extra_info"
      >
        <el-input v-model="datasArr.username"></el-input>
      </el-form-item>
      <el-form-item v-show="bannertype == 11" label="path：" prop="extra_info">
        <el-input v-model="datasArr.path"></el-input>
      </el-form-item>
      <el-form-item
        v-show="bannertype == 11"
        label="miniprogramType："
        prop="extra_info"
      >
        <!-- <el-input v-model="datasArr.miniprogramType"></el-input> -->
        <el-select v-model="miniprogramtype" placeholder="请选择">
          <el-option
            v-for="item in miniprogramtypeArr"
            :key="item.id"
            :label="item.name"
            :value="item.id"
          ></el-option>
        </el-select>
      </el-form-item>
      <el-form-item
        v-show="bannertype == 29"
        label="web_url："
        prop="extra_info"
      >
        <el-input v-model="datasArr.web_url"></el-input>
      </el-form-item>
      <el-form-item v-show="bannertype == 4" label="排序：" prop="extra_info">
        <el-select v-model="sorttype" placeholder="请选择">
          <el-option
            v-for="item in sorttypeArr"
            :key="item.sort_id"
            :label="item.name"
            :value="item.sort_id"
          ></el-option>
        </el-select>
      </el-form-item>
      <el-form-item v-show="bannertype == 4" label="科室：" prop="extra_info">
        <el-select
          v-model="departmenttype"
          @change="changedepartment"
          placeholder="请选择"
        >
          <el-option
            v-for="item in departmenttypeArr"
            :key="item.id"
            :label="item.name"
            :value="item.id"
          ></el-option>
        </el-select>
      </el-form-item>
      <el-form-item v-show="bannertype == 4" label="疾病：" prop="extra_info">
        <el-select v-model="diseasestype" placeholder="请选择">
          <el-option
            v-for="item in diseasestypeArr"
            :key="item.id"
            :label="item.name"
            :value="item.id"
          ></el-option>
        </el-select>
      </el-form-item>
      <el-form-item
        v-show="bannertype == 4"
        label="价格区间："
        prop="extra_info"
      >
        <el-select v-model="pricetype" placeholder="请选择">
          <el-option
            v-for="item in pricetypeArr"
            :key="item.id"
            :label="item.name"
            :value="item.id"
          ></el-option>
        </el-select>
      </el-form-item>
      <el-form-item
        v-show="bannertype == 4"
        label="医生职称："
        prop="extra_info"
      >
        <el-select v-model="titletype" placeholder="请选择">
          <el-option
            v-for="item in titletypeArr"
            :key="item.id"
            :label="item.name"
            :value="item.id"
          ></el-option>
        </el-select>
      </el-form-item>
      <el-form-item
        v-show="bannertype == 12 || bannertype == 13 || bannertype == 14"
        label="健康服务："
        prop="extra_info"
      >
        <el-select v-model="targettype" placeholder="请选择">
          <el-option
            v-for="item in targettypeArr"
            :key="item.id"
            :label="item.name"
            :value="item.id"
          ></el-option>
        </el-select>
      </el-form-item>
    </el-form>
    <el-button class="conbutton" type="primary" @click="postdata()"
      >提交</el-button
    >
  </div>
</template>
<script>
import http from "../../../api/hemeraApiConfig";
import http2 from "../../../api/iapetusApiConfig";
import uploadapi from "../../../api/getapi/upload";
import $ from "jquery";
// import { delete } from 'vue/types/umd';
export default {
  data() {
    return {
      datasArr: {
        web_url: "",
        target_id: "",
        keywords: "",
        appid: "",
        username: "",
        path: "",
      },
      location_type: "",
      loading: true,
      rules: {},
      cover: "",
      imageUrl: "http://coupons.jpg",
      bannertype: "",
      bannertypeArr: [],
      sorttype: "",
      sorttypeArr: [],
      departmenttype: "",
      departmenttypeArr: [],
      diseasestype: "",
      diseasestypeArr: [],
      pricetype: "",
      pricetypeArr: [],
      titletype: "",
      titletypeArr: [],
      targettype: "",
      targettypeArr: [],
      miniprogramtype: 0,
      miniprogramtypeArr: [
        {
          id: 0,
          name: "正式版",
        },
        {
          id: 1,
          name: "开发版",
        },
        {
          id: 2,
          name: "体验版",
        },
      ],
    };
  },
  props: ["dataArr"],
  created() {
    this.gettype();
    // this.getsort();
    // this.getdepartment();
    // this.getfilter();
    // this.gethealth();
  },
  methods: {
    postdata() {
      let that = this;
      // console.log(this.departmenttype)
      // console.log(this.datasArr)
      let extra_info = {};
      if (this.bannertype == 1) {
        extra_info = {
          web_url: this.datasArr.web_url,
        };
      } else if (
        this.bannertype == 3 ||
        this.bannertype == 5 ||
        this.bannertype == 27
      ) {
        extra_info = {
          target_id: this.datasArr.target_id,
        };
      } else if (this.bannertype == 4) {
        // let priceid = "";
        // let titleid = "";
        // if (this.datasArr.price_id != undefined) {
        //   priceid = this.datasArr.price_id.replace(/，/g, ",");
        // }
        // if (this.datasArr.title_id != undefined) {
        //   titleid = this.datasArr.title_id.replace(/，/g, ",");
        // }
        extra_info = {
          sort_id: this.sorttype,
          department_id: this.departmenttype,
          disease_id: this.diseasestype,
          price_id: this.pricetype,
          title_id: this.titletype,
        };
      } else if (this.bannertype == 6) {
        extra_info = {
          keywords: this.datasArr.keywords,
        };
      } else if (this.bannertype == 11) {
        extra_info = {
          appid: this.datasArr.appid,
          username: this.datasArr.username,
          path: this.datasArr.path,
          miniprogramType: this.miniprogramtype,
        };
        console.log(extra_info, "extra_info");
      } else if (this.bannertype == 29) { 
        extra_info = {
          web_url: this.datasArr.web_url,
        };
      } else {
        extra_info = "";
      }
      let newextra_info = JSON.stringify(extra_info);
      // console.log(newextra_info)
      // console.log(extra_info.toJSONString());
      let params = {
        img_path: this.imageUrl,
        type: this.bannertype,
        extra_info: newextra_info,
        enable: 0,
        location_type: this.location_type,
      };
      http.post("admin/banners", params).then(function(res) {
        // console.log(res);
        if (res.data.status_code == 200) {
          that.$emit("putsuccess", 1);
        }
      });
    },
    gettype() {
      let that = this;
      let url = "admin/banners_type?location_type=" + this.location_type;
      http.get(url).then(function(res) {
        // that.datasArr['web_url'] = ''
        console.log(res);
        // that.bannertypeArr = res.data.data;
        let arr = res.data.data;
        // console.log(that.location_type);
        if (that.location_type == 2) {
          arr.forEach(function(item, index, arr) {
            if (item.name === "健康服务" || item.name === "健康评估") {
              arr.splice(index, 1);
            }
          });
          that.bannertypeArr = arr;
        } else {
          that.bannertypeArr = res.data.data;
        }
        console.log(that.bannertypeArr);
        that.bannertype = that.bannertypeArr[0].id;
      });
    },
    getsort() {
      let that = this;
      http2.get("common/sort").then(function(res) {
        // that.datasArr["web_url"] = "";
        // console.log(res)
        that.sorttypeArr = res.data.data;
        that.sorttype = that.sorttypeArr[0].sort_id;
        // console.log(that.sorttypeArr[0])
        // console.log(that.datasArr)
      });
    },
    getdepartment() {
      let that = this;
      http2.get("departments").then(function(res) {
        // console.log(res);
        that.departmenttypeArr = res.data.data;
        that.departmenttype = that.departmenttypeArr[0].id;
        that.diseasestypeArr = that.departmenttypeArr[0].list;
        that.diseasestype = that.departmenttypeArr[0].list[0].id;
        // console.log(that.departmenttypeArr[0])
        // console.log(that.datasArr)
      });
    },
    getfilter() {
      let that = this;
      http2.get("common/filter").then(function(res) {
        // console.log(res);
        that.pricetypeArr = res.data.data[0].items;
        that.pricetype = that.pricetypeArr[0].id;
        that.titletypeArr = res.data.data[1].items;
        that.titletype = that.titletypeArr[0].id;
        // console.log(that.datasArr)
      });
    },
    gethealth(num) {
      let that = this;
      let params = {
        type: num,
      };
      http.get("admin/health", { params }).then(function(res) {
        // console.log(res);
        that.targettypeArr = res.data.data;
        that.targettype = that.targettypeArr[0].id;
        // that.titletypeArr = res.data.data[1].items;
        // that.titletype = that.titletypeArr[0].id;
        // console.log(that.datasArr)
      });
    },
    changetype(val) {
      // console.log(val);
      if (val == 4) {
        this.getsort();
        this.getdepartment();
        this.getfilter();
      } else if (val == 12) {
        this.gethealth(1);
      } else if (val == 13) {
        this.gethealth(2);
      } else if (val == 14) {
        this.gethealth(3);
      }
    },
    changedepartment(val) {
      // console.log(val)
      let item = [];
      for (let i = 0; i < this.departmenttypeArr.length; i++) {
        if (val == this.departmenttypeArr[i].id) {
          // console.log(i)
          item = this.departmenttypeArr[i].list;
        }
      }
      // console.log(item)
      this.diseasestypeArr = item;
      this.diseasestype = item[0].id;
    },
    beforeAvatarUpload(file) {
      // console.log(file);
      let that = this;
      // this.cover = URL.createObjectURL(file);
      // console.log(this.cover);
      const isJPG = file.type === "image/jpeg" || "image/png";
      const isLt2M = file.size / 1024 / 1024 < 2;
      if (isJPG && isLt2M) {
        var ossData = new FormData();
        let imgType = file.type.split("/")[1];
        var filename = file.name.split(".")[0] + "." + imgType;
        // console.log(filename);
        ossData.append("work_path", "common/banner");
        ossData.append("bucket", "family-tcm");
        ossData.append("end_point", "oss-cn-hangzhou.aliyuncs.com");
        ossData.append("rewrite", "1");
        ossData.append("file_name", filename);
        ossData.append("file", file);
        // console.log(ossData);
        let apiURL = "";
        // console.log(process.env.NODE_ENV)
        if (process.env.NODE_ENV === "development") {
          // alert("开发环境");
          apiURL = "http://proxy.jiankanghao.net:50215/api/v1/";
        } else {
          // alert("生产环境");
          apiURL = uploadapi;
        }
        $.ajax({
          url: apiURL + "upload",
          type: "POST",
          data: ossData,
          contentType: false,
          processData: false,
          success: function(data) {
            console.log(data);
            that.imageUrl = "common/banner/" + filename;
            that.cover = URL.createObjectURL(file);
            let params = {
              work_path: that.imageUrl,
              end_point: "oss-cn-shanghai.aliyuncs.com",
              bucket: "family-tcm",
            };
            http.get("info", params).then(function(res1) {
              console.log(res1);
              that.cover = res1.data.data.url;
            });
          },
          error: function() {
            console.log("上传失败！");
          },
        });
      } else if (!isJPG) {
        this.$message.error("上传头像图片只能是 JPG 格式!");
      } else if (!isLt2M) {
        this.$message.error("上传头像图片大小不能超过 2MB!");
      }
      return isJPG && isLt2M;
    },
    pushdata(formName) {
      this.$refs[formName].validate((valid) => {
        // console.log(this.status);
        if (valid) {
          //   if (this.status == "put") {
          //     this.putdata();
          //   } else {
          //     this.postdata();
          //   }
        } else {
          console.log("error submit!!");
          return false;
        }
      });
    },
    putdata() {},
  },
  watch: {
    dataArr: {
      immediate: true,
      handler(val) {
        this.location_type = val.location_type;
        this.gettype();
      },
    },
  },
};
</script>
<style scoped>
.conbutton {
  display: block;
  margin: 0 auto;
}
.fc {
  color: #606266;
}
</style>
